export default __webpack_public_path__ + "static/media/garou.73bd6199.png";